import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withApollo, gql } from 'react-apollo'
import Auth from 'store/Auth'
import styled from 'styled-components'

import Color from 'helpers/Color'
import {
  Segment,
  Logo,
  Loading,
} from 'components/UI'
import LoginForm from './LoginForm'
import FirstLoginForm from './FirstLoginForm'

const Wrapper = styled.div`
  background-color: ${Color.green};
  height: 100vh;
  display: flex;
  padding-bottom: 10%;
  min-height: 300px;
`
const InnerWrapper = styled.div`
  margin: auto;
  width: 600px;
`

class Login extends Component {
  handleLoginClick = (email, password) => {
    const {
      login,
      setRole,
      client,
    } = this.props

    login(email, password)
    .then(auth => client.query({
      query: RoleQuery,
      variables: {
        cognitoId: auth.userDetails.sub,
      },
    }))
    .then(({ data }) => {
      const role = data.user.type

      setRole(role)
      client.mutate({
        mutation: role === 'Manager' ? ManagerUpdateMutation : SuperUpdateMutation,
        variables: data,
      })
    })
    .catch(error => console.error(error))
  }

  handleFirstLoginSubmit = (attributes) => {

    this.props.activateAccount(attributes)
  }

  render () {
    const {
      authStatus,
      userDetails,
      rehydrated,
    } = this.props
  
    const loading = authStatus === Auth.LOGGING_IN
    const firstLogin = authStatus === Auth.FIRST_LOGIN
  
    return (
      <Wrapper>
        <InnerWrapper>
          <Logo />
          { rehydrated && (loading ? (
            <Loading />
          ) : (
            <Segment centered autoHeight>
              { firstLogin ? (
                <FirstLoginForm
                  onSubmit={this.handleFirstLoginSubmit}
                  email={userDetails.email}
                />
              ) : (
                <LoginForm onSubmit={this.handleLoginClick} />
              )}
            </Segment>
          ))}
        </InnerWrapper>
      </Wrapper>
    )
  }
}

const RoleQuery = gql`
  query RoleQuery($cognitoId: String!) {
    user(cognitoId: $cognitoId) {
      type
    }
  }
`

const ManagerUpdateMutation = gql`
  mutation ManagerUpdateMutation(
    $givenName: String,
    $familyName: String,
    $email: String
    $phone: String,
  ) {
    updateManager(
      givenName: $givenName,
      familyName: $familyName,
      email: $email,
      phone: $phone
    ) {
      id
    }
  }
`

const SuperUpdateMutation = gql`
  mutation SuperUpdateMutation(
    $givenName: String,
    $familyName: String,
  ) {
    updateSuperintendent(
      givenName: $givenName,
      familyName: $familyName,
    ) {
      message
    }
  }
`

const mapStateToProps = state => ({
  authStatus: state.auth.status,
  userDetails: state.auth.userDetails,
})

const mapDispatchToProps = dispatch => ({
  login: (email, password) => dispatch(Auth.login(email, password)),
  setRole: (role) => dispatch(Auth.setRole(role)),
  activateAccount: attributes => dispatch(Auth.activateAccount(attributes)),
})

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(Login))



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx